import { useEffect, useMemo, useState } from 'react';
import { cookieProvider } from '@/providers/CookieProvider';

export type SafeAreaInsets = {
    top: number;
    bottom: number;
    left: number;
    right: number;
};

const ZERO_INSETS: SafeAreaInsets = { top: 0, bottom: 0, left: 0, right: 0 };

function readSafeAreaInsets(): SafeAreaInsets {
    const raw = cookieProvider.get('safeAreaInsets');
    if (!raw || typeof raw !== 'object') return ZERO_INSETS;

    const value = raw as Record<string, unknown>;
    return {
        top: Number(value.top) || 0,
        bottom: Number(value.bottom) || 0,
        left: Number(value.left) || 0,
        right: Number(value.right) || 0,
    };
}

/** Reads decrypted `safeAreaInsets` from the shared cookie (same as `authToken`). */
export function useSafeAreaInsets() {
    const [insets, setInsets] = useState<SafeAreaInsets>(ZERO_INSETS);

    useEffect(() => {
        setInsets(readSafeAreaInsets());
    }, []);

    const topSafeComponent = useMemo(() => {
        if (insets.top <= 0) return null;
        return <div style={{ height: insets.top+'px', width: '100%' }} aria-hidden />;
    }, [insets.top]);

    const bottomSafeComponent = useMemo(() => {
        if (insets.bottom <= 0) return null;
        return <div style={{ height: insets.bottom+'px', width: '100%' }} aria-hidden />;
    }, [insets.bottom]);

    return { ...insets, topSafeComponent, bottomSafeComponent };
}
